(() => {
  if (window.__MTS_SIZE_QUIZ_DRAWER_V2__) return;
  window.__MTS_SIZE_QUIZ_DRAWER_V2__ = true;

  const SIZES = ["S", "M", "L", "XL", "XXL"];
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const qs = (r, s) => r.querySelector(s);
  const qsa = (r, s) => Array.from(r.querySelectorAll(s));

  // =========================================
  // 1) Algo recommandation simple (stable)
  // =========================================
  function sizeFromProfile(heightCm, weightKg, fit) {
    const h = heightCm / 100;
    const bmi = weightKg / (h * h);
    let score = bmi + (heightCm - 175) / 40;

    let idx =
      score < 22 ? 0 :
      score < 25 ? 1 :
      score < 28 ? 2 :
      score < 31 ? 3 : 4;

    if (fit === "slim") idx -= 1;
    if (fit === "loose") idx += 1;
    idx = clamp(idx, 0, SIZES.length - 1);

    const centers = [21, 24, 27, 30, 33];
    const d = Math.min(6, Math.abs(score - centers[idx]));
    const confidence = Math.round(clamp(98 - d * 6, 78, 98));

    const text =
      fit === "slim"
        ? "Tu as choisi un rendu ajusté : plus près du corps."
        : fit === "loose"
        ? "Tu as choisi un rendu large : plus confort."
        : "La majorité des personnes avec un profil similaire choisissent cette taille.";

    return { size: SIZES[idx], confidence, text };
  }

  // =========================================
  // 2) Appliquer la taille au formulaire produit
  // =========================================
  function applySizeToProductForm(widget, size) {
    const scope = widget.closest("section, .shopify-section, main, body") || document;

    // Select
    const selects = qsa(scope, 'select[name^="options"], select[name*="options"]');
    for (const sel of selects) {
      const name = (sel.getAttribute("name") || "").toLowerCase();
      if (name.includes("taille") || name.includes("size")) {
        const opt = Array.from(sel.options).find(o => (o.value || "").trim().toUpperCase() === size);
        if (opt) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
          return true;
        }
      }
    }

    // Radios
    const radios = qsa(scope, 'input[type="radio"][name^="options"], input[type="radio"][name*="options"]');
    for (const r of radios) {
      const val = (r.value || "").trim().toUpperCase();
      const name = (r.getAttribute("name") || "").toLowerCase();
      if ((name.includes("taille") || name.includes("size")) && val === size) {
        r.checked = true;
        r.dispatchEvent(new Event("change", { bubbles: true }));
        r.dispatchEvent(new Event("input", { bubbles: true }));
        return true;
      }
    }

    // Labels fallback
    const labels = qsa(scope, "label");
    for (const lab of labels) {
      const t = (lab.textContent || "").trim().toUpperCase();
      if (t === size) {
        lab.click();
        return true;
      }
    }

    return false;
  }

  // =========================================
  // 3) Scroll lock (mobile safe)
  // =========================================
  let savedScrollY = 0;
  function lockScroll(lock) {
    if (lock) {
      savedScrollY = window.scrollY || 0;
      document.body.style.position = "fixed";
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, savedScrollY);
    }
  }

  // =========================================
  // 4) Gestion globale : un seul drawer ouvert à la fois
  // =========================================
  let ACTIVE = null;
  function closeActive() {
    if (ACTIVE && typeof ACTIVE.close === "function") ACTIVE.close();
  }

  // =========================================
  // 5) Init d’un widget
  // =========================================
  function initOne(widget) {
    const btnOpen = qs(widget, "[data-mts-sq-open]");
    const overlay = qs(widget, "[data-mts-sq-overlay]");
    const panel = qs(widget, "[data-mts-sq-panel]");
    const btnClose = qs(widget, "[data-mts-sq-close]");
    const btnBack = qs(widget, "[data-mts-sq-back]");
    const bar = qs(widget, "[data-mts-sq-bar]");

    const heightR = qs(widget, "[data-mts-sq-height]");
    const weightR = qs(widget, "[data-mts-sq-weight]");
    const hVal = qs(widget, "[data-mts-sq-height-val]");
    const wVal = qs(widget, "[data-mts-sq-weight-val]");

    const fitBtns = qsa(widget, "[data-mts-sq-fit]");
    const btnNexts = qsa(widget, "[data-mts-sq-next]");
    const btnApply = qs(widget, "[data-mts-sq-apply]");
    const btnRestart = qs(widget, "[data-mts-sq-restart]");

    const outSize = qs(widget, "[data-mts-sq-result-size]");
    const outConf = qs(widget, "[data-mts-sq-result-confidence]");
    const outText = qs(widget, "[data-mts-sq-result-text]");

    const steps = qsa(widget, ".mts-sq__step");

    if (!overlay || !panel) return;

    // --- Placeholders pour remettre overlay/panel à leur place à la fermeture
    const overlayAnchor = document.createComment("mts-sq-overlay-anchor");
    const panelAnchor = document.createComment("mts-sq-panel-anchor");
    overlay.parentNode.insertBefore(overlayAnchor, overlay);
    panel.parentNode.insertBefore(panelAnchor, panel);

    // --- Etat initial : TOUJOURS fermé
    overlay.hidden = true;
    panel.hidden = true;
    panel.classList.remove("is-open");

    let step = 0;
    let fit = "regular";
    let isOpen = false;

    function showStep(n) {
      step = n;
      steps.forEach(s => (s.hidden = s.getAttribute("data-step") !== String(step)));
      if (btnBack) btnBack.hidden = step <= 0;
      if (bar) bar.style.width = `${Math.round((step / 4) * 100)}%`;
    }

    function computeAndRender() {
      const h = Number(heightR?.value || 175);
      const w = Number(weightR?.value || 70);
      const res = sizeFromProfile(h, w, fit);

      if (outSize) outSize.textContent = res.size;
      if (outConf) outConf.textContent = String(res.confidence);
      if (outText) outText.textContent = res.text;

      try {
        localStorage.setItem("mts_size_quiz", JSON.stringify({ height: h, weight: w, fit, ...res }));
      } catch (e) {}

      return res;
    }

    function moveToBodyForTopLayer() {
      // ✅ met réellement au-dessus des éléments "piégeants" (header/whatsapp/pack)
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      if (panel.parentNode !== document.body) document.body.appendChild(panel);
    }

    function restoreToAnchors() {
      // remet au bon endroit dans le DOM (propre)
      if (overlayAnchor.parentNode) overlayAnchor.parentNode.insertBefore(overlay, overlayAnchor.nextSibling);
      if (panelAnchor.parentNode) panelAnchor.parentNode.insertBefore(panel, panelAnchor.nextSibling);
    }

    function open() {
      if (isOpen) return;

      // ferme un autre quiz ouvert
      closeActive();

      isOpen = true;
      ACTIVE = api;

      moveToBodyForTopLayer();

      overlay.hidden = false;
      panel.hidden = false;

      // reset swipe inline styles
      panel.style.transition = "";
      panel.style.transform = "";
      overlay.style.opacity = "";

      lockScroll(true);

      // animation: classe sur PANEL (comme ton CSS)
      requestAnimationFrame(() => {
        panel.classList.add("is-open");
      });

      panel.setAttribute("aria-hidden", "false");
      overlay.setAttribute("aria-hidden", "false");

      showStep(0);

      // focus utile (sans casser mobile)
      setTimeout(() => {
        const focusable = panel.querySelector("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
        if (focusable) focusable.focus({ preventScroll: true });
      }, 50);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      panel.classList.remove("is-open");
      lockScroll(false);

      // attendre la transition du drawer, puis hide + restore DOM
      setTimeout(() => {
        overlay.hidden = true;
        panel.hidden = true;

        // reset inline swipe
        panel.style.transform = "";
        panel.style.transition = "";
        overlay.style.opacity = "";

        restoreToAnchors();

        if (ACTIVE === api) ACTIVE = null;
      }, 260);
    }

    // --- API pour gestion globale
    const api = { open, close };

    // =========================================
    // Events UI
    // =========================================
    btnOpen?.addEventListener("click", (e) => {
      e.preventDefault();
      open();
    });

    btnClose?.addEventListener("click", (e) => {
      e.preventDefault();
      close();
    });

    overlay.addEventListener("click", () => close());

    // ESC : un seul listener global
    if (!window.__MTS_SQ_ESC__) {
      window.__MTS_SQ_ESC__ = true;
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeActive();
      });
    }

    btnBack?.addEventListener("click", () => showStep(Math.max(0, step - 1)));

    btnNexts.forEach((b) =>
      b.addEventListener("click", () => {
        if (step === 3) {
          computeAndRender();
          showStep(4);
        } else {
          showStep(Math.min(4, step + 1));
        }
      })
    );

    heightR?.addEventListener("input", () => {
      if (hVal) hVal.textContent = heightR.value;
    });

    weightR?.addEventListener("input", () => {
      if (wVal) wVal.textContent = weightR.value;
    });

    fitBtns.forEach((b) =>
      b.addEventListener("click", () => {
        fitBtns.forEach((x) => x.classList.remove("is-active"));
        b.classList.add("is-active");
        fit = b.getAttribute("data-mts-sq-fit") || "regular";
      })
    );
// ✅ UX like Fincut: cliquer une option avance direct vers résultat
fitBtns.forEach((b) => {
  b.addEventListener("click", () => {
    // active style
    fitBtns.forEach((x) => x.classList.remove("is-active"));
    b.classList.add("is-active");
    fit = b.getAttribute("data-mts-sq-fit") || "regular";

    // go next directly (step 3 -> step 4)
    if (step === 3) {
      computeAndRender();
      showStep(4);
    }
  });
});

    btnRestart?.addEventListener("click", () => showStep(0));

    btnApply?.addEventListener("click", () => {
      const res = computeAndRender();
      applySizeToProductForm(widget, res.size);
      close();
    });

    // =========================================
    // Swipe down pour fermer (mobile)
    // =========================================
    let startY = 0;
    let curY = 0;
    let dragging = false;

    panel.addEventListener(
      "touchstart",
      (e) => {
        if (!isOpen) return;

        // si on commence le swipe sur un élément scrollable pas en haut -> on évite de fermer
        const body = panel.querySelector(".mts-sq__body");
        if (body && body.scrollTop > 0) return;

        dragging = true;
        startY = e.touches[0].clientY;
        curY = startY;

        panel.style.transition = "none";
      },
      { passive: true }
    );

    panel.addEventListener(
      "touchmove",
      (e) => {
        if (!dragging || !isOpen) return;

        curY = e.touches[0].clientY;
        const dy = Math.max(0, curY - startY);

        // suit le doigt
        panel.style.transform = `translate3d(0, ${dy}px, 0)`;

        // overlay devient plus transparent
        const op = clamp(1 - dy / 260, 0.35, 1);
        overlay.style.opacity = String(op);
      },
      { passive: true }
    );

    panel.addEventListener("touchend", () => {
      if (!dragging || !isOpen) return;
      dragging = false;

      const dy = Math.max(0, curY - startY);

      // restore transition
      panel.style.transition = "";
      panel.style.transform = "";
      overlay.style.opacity = "";

      if (dy > 110) {
        close();
      } else {
        // revient en place
        panel.classList.add("is-open");
      }
    });

    // =========================================
    // Restore saved values (optionnel)
    // =========================================
    try {
      const saved = JSON.parse(localStorage.getItem("mts_size_quiz") || "null");
      if (saved) {
        if (heightR) {
          heightR.value = saved.height || 175;
          if (hVal) hVal.textContent = heightR.value;
        }
        if (weightR) {
          weightR.value = saved.weight || 70;
          if (wVal) wVal.textContent = weightR.value;
        }
        if (saved.fit) {
          fit = saved.fit;
          fitBtns.forEach((x) =>
            x.classList.toggle("is-active", x.getAttribute("data-mts-sq-fit") === fit)
          );
        }
      }
    } catch (e) {}

    // ✅ toujours step 0 au chargement
    showStep(0);
  }

  // =========================================
  // Boot
  // =========================================
  function boot() {
    document.querySelectorAll("[data-mts-size-quiz]").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();